import { Body02, Button, ButtonBaseProps, ButtonProps, Headline06 } from 'Components/designSystem';
import React, { memo } from 'react';
import styled from 'styled-components';

import StatusIcon, { StatusIconVariantProps } from './StatusIcon';

type StatusScreenProps = {
    title?: string;
    description?: string;
    buttonProps?: ButtonBaseProps & ButtonProps;
} & StatusIconVariantProps;

function StatusScreen(props: StatusScreenProps) {
    const {
        buttonProps,
        description,
        icon,
        title,
        variant
    } = props;

    return (
        <Root>
            {
                variant === 'custom'
                    ? (
                        <StyledStatusIcon variant={ variant }
                            icon={ icon }
                        />
                    )
                    : <StyledStatusIcon variant={ variant } />
            }

            { Boolean(title) && <StyledHeadline06>{ title }</StyledHeadline06> }

            { Boolean(description) && <StyledBody02>{ description }</StyledBody02> }

            { buttonProps && <Button { ...buttonProps } /> }
        </Root>
    );
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: ${ ({ theme }) => theme.size.size_30 };
`;

const StyledStatusIcon = styled(StatusIcon)`
    &:not(:last-child) {
        margin-bottom: ${ ({ theme }) => theme.size.size_20 };
    }
`;

const StyledHeadline06 = styled(Headline06)`
    &:not(:last-child) {
        margin-bottom: ${ ({ theme }) => theme.size.size_10 };
    }
`;

const StyledBody02 = styled(Body02)`
    text-align: center;
    color: ${ ({ theme }) => theme.color.grey.grey_60 };

    &:not(:last-child) {
        margin-bottom: ${ ({ theme }) => theme.size.size_30 };
    }
`;

export default memo(StatusScreen);
